import { useEffect, useRef } from 'react';

/**
 * Dialoge: beim Öffnen den Fokus in den Dialog holen (falls dort noch nichts fokussiert ist) und beim
 * Schließen an das Element zurückgeben, das vorher fokussiert war (z. B. den auslösenden Knopf).
 */
export function useDialogFokus<T extends HTMLElement>() {
  const dialog = useRef<T>(null);
  useEffect(() => {
    const vorher = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const d = dialog.current;
    if (d && !d.contains(document.activeElement)) d.focus({ preventScroll: true });
    return () => { if (vorher?.isConnected) vorher.focus({ preventScroll: true }); };
  }, []);
  return dialog;
}
